import React from "react";

const ReportLayout = ({ children }) => {
    return <div className="report"><div className="report-wrapper">{children}</div></div>;
};

export default ReportLayout;